jQuery(document).ready(function($) {
  $('.faq-tabs').on('change.zf.tabs', function() {
    if($(this).next('label').find('select').val() !== $(this).find('a[aria-selected="true"]').attr('href')) {
      $(this).next('label').find('select').val($(this).find('a[aria-selected="true"]').attr('href'));
    }
  });

  $('.faq-select').on('change', function() {
    $(this).parents('.cell').find('ul a[href="'+$(this).val()+'"]').click();
  });
});
